import { List as ConfirmationList } from './List';

export default ConfirmationList;
